import { useEffect, useState } from 'react';

const useInterceptionObserver = ({ elements }) => {
    const [current, setCurrent] = useState(elements[0].text);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                // let currentIntersectionRatio = 0;
                let currentText = '';

                entries.forEach((item) => {
                    const ratio = item.intersectionRatio;
                    if (ratio > 0) {
                        // currentIntersectionRatio = ratio;
                        const currentId = item.target.className;
                        currentText = elements.find((item) => item.id === currentId)?.text;
                        // console.log('113906 useInterceptionObserver.js ratio', ratio, currentText);
                    }
                });

                if (currentText) {
                    setCurrent(currentText);
                }

                // setData(
                //     produce((draft) => {
                //         entries.forEach((item) => {
                //             const currentClassName = item.target.className;
                //             const currentRatio = item.intersectionRatio;

                //             const draftIndex = draft.findIndex((item) => {
                //                 return item.id === currentClassName;
                //             });

                //             draft[draftIndex].ratio = currentRatio;
                //         });
                //     }),
                // );
            },
            { rootMargin: '0px 0px -200px 0px' },
        );

        elements.forEach((item) => {
            const element = document.querySelector(`.${item.id}`);

            if (element) {
                observer.observe(element);
            }
        });

        return () => {
            observer.disconnect();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements]);

    return current;
};

export default useInterceptionObserver;
